// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	userPoolId: 'eu-central-1_ulAvDjVLW',
	userPoolWebClientId: '1d86u9583jn2djo3vat5redjrm',
	identityPoolId: 'eu-central-1:3b0da052-b5dc-4fb2-b7df-03267ec1896c',
	identityPoolRegion: 'eu-central-1',
	agGridLicenseKey: 'CompanyName=CANCOM Managed Services GmbH,LicensedGroup=ag-Grid-cc-MaSe_1 , ag-Grid-cc-MaSe_2,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=2,LicensedProductionInstancesCount=0,AssetReference=AG-013613,ExpiryDate=15_February_2022_[v2]_MTY0NDg4MzIwMDAwMA==22fdf444272b066ddc6027bd01fd84b5'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
